import { create } from 'zustand';
import { TeamColor } from '../types/wargame-teams';
import { SubmittedAction } from './adjudicationStore';

export interface TeamState {
  id: TeamColor;
  name: string;
  color: string;
  isHuman: boolean;
  iloeCapacity: number;
  capabilitySlots: number;
  ready: boolean;
}

interface TeamStore {
  teams: TeamState[];
  currentTeamTurn: TeamColor;
  teamPhase: 'planning' | 'adjudication';
  
  initializeTeams: (playerCount: number) => void;
  setTeamReady: (teamId: TeamColor, isReady: boolean) => void;
  submitTeamActions: (teamId: TeamColor, actions: SubmittedAction[]) => void;
  rotateTeamTurn: () => void;
  getAllTeamResources: () => Record<TeamColor, { iloe: number, slots: number }>;
  notifyTeamOfTurn: (teamId: TeamColor) => void;
}

const TEAM_CONFIGS: Record<number, { id: TeamColor, name: string, color: string }[]> = {
  0: [{ id: 'Blue', name: 'Blue Team', color: 'bg-blue-500' }, { id: 'Red', name: 'Red Team', color: 'bg-red-500' }], // Default
  // Add more configs
};

export const useTeamStore = create<TeamStore>((set, get) => ({
  teams: [],
  currentTeamTurn: 'Blue',
  teamPhase: 'planning',

  initializeTeams: (playerCount) => {
    // Simplified initialization
    const initialTeams: TeamState[] = [
      { id: 'Blue', name: 'Blue Team', color: 'bg-blue-500', isHuman: true, iloeCapacity: 100, capabilitySlots: 20, ready: false },
      { id: 'Red', name: 'Red Team', color: 'bg-red-500', isHuman: false, iloeCapacity: 100, capabilitySlots: 20, ready: false }
    ];
    set({ teams: initialTeams, currentTeamTurn: 'Blue' });
  },

  setTeamReady: (teamId, isReady) => {
    const { teams } = get();
    const updatedTeams = teams.map(t => t.id === teamId ? { ...t, ready: isReady } : t);
    set({ teams: updatedTeams });
  },

  submitTeamActions: (teamId, actions) => {
    // Logic to queue actions
    // This might interface with adjudicationStore
  },

  rotateTeamTurn: () => {
    const { teams, currentTeamTurn } = get();
    const currentIndex = teams.findIndex(t => t.id === currentTeamTurn);
    const nextIndex = (currentIndex + 1) % teams.length;
    set({ currentTeamTurn: teams[nextIndex].id });
  },

  getAllTeamResources: () => {
    const { teams } = get();
    const resources: any = {};
    teams.forEach(t => {
      resources[t.id] = { iloe: t.iloeCapacity, slots: t.capabilitySlots };
    });
    return resources;
  },

  notifyTeamOfTurn: (teamId) => {
    // Notification logic
    console.log(`Turn started for ${teamId}`);
  }
}));
